import angular from 'angular';

/**
 * Get angularJs injector service
 * @param serviceName
 * @returns
 */
export const getInjector = () => angular.element(document).injector();
